<script>
	import Offer from "./offer.svelte";
	import ScreenSaver from "./screen-saver.svelte";
	import Lobby from "./lobby.svelte";
	import History from "./history.svelte";
	import Auth from "./auth.svelte";
	import {
		token,
		balance,
		jackpots,
		apiHost,
		isOut,
		pusherConnector,
		historyState,
		denomination,
		denominations,
		games,
		terminalNumber,
		isScreenSaverVisible,
		isOfferVisible,
		hosts,
		debug,
		offer,
	} from "./stores";
	import Offer4 from "./offer4.svelte";
	const handleKeydown = (e) => e.keyCode != 27;
	export let iframe = false;
	if (!iframe) {
		const url = new URL(location);
		const newToken = url.searchParams.get("token");
		if (newToken) {
			localStorage.setItem("token", newToken);
			url.searchParams.delete("token");
			window.history.pushState("", "", url.href);
			$token = newToken;
		}

		if ($token) {
			auth();
		} else {
			/*url.hostname = url.hostname.replace(/^loto\./, "");
			console.log("redirect", url);
			location = url;*/
		}
	}

	let lastAction = Date.now();
	function detectAction() {
		lastAction = Date.now();
	}
	function chechAction() {
		if (
			$terminalNumber.length > 0 &&
			$terminalNumber[0] !== "0" &&
			!$isScreenSaverVisible &&
			Date.now() - lastAction > 1000 * 60 * 2
		) {
			$isScreenSaverVisible = true;
			$isOfferVisible = true;
		}
	}
	setInterval(chechAction, 5000);

	function sendToken(frameId) {
		localStorage.removeItem("newAuth");
		document
			.querySelector("#" + frameId)
			.contentWindow.postMessage({ token: $token }, "*");
	}

	function auth() {
		fetch(`${apiHost}v1/info`, {
			headers: new Headers({
				Authorization: "Bearer " + $token,
			}),
		})
			.then((r) => r.json())
			.then((r) => {
				if (r.success === true) {
					if (
						r.data.hall_template !== 3 &&
						hosts[r.data.hall_template]
					) {
						if (debug) {
							console.log(
								`redirect to ${hosts[r.data.hall_template]}`,
							);
						} else {
							location.href = hosts[r.data.hall_template];
						}
					}
					$denominations = r.data.denominations;
					$denomination = r.data.denomination;
					$balance = r.data.balance;
					$isOut = r.data.is_out;
					$offer = r.data.offer;
					const numbers = r.data.name
						.replace(/\D+/g, "-")
						.split("-")
						.filter((x) => x !== "");
					$terminalNumber =
						numbers.length === 0 ? "" : numbers[numbers.length - 1];
					if (r.data.jackpots) {
						if (!$jackpots) {
							$jackpots = {};
						}
						for (let k in r.data.jackpots) {
							$jackpots[k] = Math.floor(
								(0.7 * r.data.jackpots[k]) / $denomination,
							);
						}
					}
					pusherConnector(
						r.data.id,
						r.data.pusher.key,
						r.data.pusher.cluster,
						`${apiHost}auth/pusher`,
						$token,
					);
				} else {
					localStorage.removeItem("token");
					location.search = "";
				}
			});
		fetch(`${apiHost}v1/games`, {
			headers: new Headers({
				Authorization: "Bearer " + $token,
			}),
		})
			.then((r) => r.json())
			.then((r) => {
				if (r.success === true) {
					r.data.some((obj) => {
						if (obj.package.name.indexOf("wbg") >= 0) {
							$games = obj.games.map((e) => e.id);
							return true;
						}
						return false;
					});
				}
			});
	}
</script>

<svelte:window
	on:keydown={handleKeydown}
	on:keyup={handleKeydown}
	on:mousemove={detectAction}
/>

{#if !iframe}
	{#if localStorage.getItem("newAuth")}
		{#each hosts as host, i}
			{#if host}
				<iframe
					style="display:none"
					id={`frame-${i}`}
					title={`frame-${i}`}
					src={`${host}/?action=set-token`}
					on:load={() => $token && sendToken(`frame-${i}`)}
				/>
			{/if}
		{/each}
	{/if}
	{#if $historyState === 2}
		<History />
	{:else}
		{#if !$token}
			<Auth />
		{/if}
		<Lobby />
		{#if $offer === 4}
			<Offer4 />
		{:else if $offer === 3}
			<Offer />
		{/if}
		<ScreenSaver number={$terminalNumber} />
	{/if}
{/if}

<style>
	:global(*) {
		padding: 0;
		margin: 0;
	}

	:global(html) {
		width: 100%;
		height: 100%;
		overflow: hidden;
		margin: 0;
		padding: 0;
		position: fixed;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		/*должно решить проблему с подвалами*/
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
		background-color: #011b22;
	}

	:global(body) {
		width: 100%;
		height: 100%;
		position: fixed;
		overflow: hidden;
		margin: 0;
		padding: 0;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}
</style>
